// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-code.js';

import { paths } from '../generated/file-code';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-code', Original, paths);
